import React from "react";
import styles from "./PaymentMethodDisplayCard.module.css";

function formatBrand(value) {
  if (!value) return "כרטיס שמור";
  return String(value)
    .replace(/_/g, " ")
    .replace(/\b\w/g, (letter) => letter.toUpperCase());
}

function formatExpiry(month, year) {
  if (!month || !year) return "";
  return `תוקף ${String(month).padStart(2, "0")}/${year}`;
}

export default function PaymentMethodDisplayCard({
  paymentMethod,
  variant = "profile",
  selected = false,
  selectable = false,
  isDefault = false,
  onSelect,
  onSetDefault,
  onRemove,
}) {
  const brand = formatBrand(paymentMethod?.card_brand || paymentMethod?.brand);
  const last4 = paymentMethod?.card_last4 || paymentMethod?.last4 || "";
  const expiry = formatExpiry(
    paymentMethod?.exp_month || paymentMethod?.card_exp_month,
    paymentMethod?.exp_year || paymentMethod?.card_exp_year
  );
  const holderName = paymentMethod?.holder_name || paymentMethod?.card_holder_name || "";

  const handleClick = () => {
    if (selectable && onSelect) onSelect(paymentMethod);
  };

  return (
    <div
      className={`${styles.card} ${styles[variant] || ""} ${
        selectable ? styles.selectable : ""
      } ${selected ? styles.selected : ""}`}
      dir="rtl"
      onClick={handleClick}
      role={selectable ? "button" : undefined}
      tabIndex={selectable ? 0 : undefined}
    >
      <div className={styles.iconWrap} aria-hidden="true">
        <span className={styles.cardIcon} />
      </div>

      <div className={styles.content}>
        <div className={styles.titleRow}>
          <strong>{brand}</strong>
          {last4 && <span className={styles.last4}>{"••••"} {last4}</span>}
          {isDefault && <span className={styles.badgeDefault}>ברירת מחדל</span>}
          {!isDefault && <span className={styles.badge}>פעיל</span>}
        </div>

        <div className={styles.meta}>
          {expiry && <span>{expiry}</span>}
          {holderName && variant !== "compact" && <span>{holderName}</span>}
          {!expiry && !holderName && <span>אמצעי התשלום שמור ומוכן לשימוש</span>}
        </div>

        {(onSetDefault || onRemove) && (
          <div className={styles.actions}>
            {onSetDefault && !isDefault && (
              <button
                type="button"
                className={styles.actionBtn}
                onClick={(e) => {
                  e.stopPropagation();
                  onSetDefault(paymentMethod);
                }}
              >
                הגדר כברירת מחדל
              </button>
            )}
            {onRemove && (
              <button
                type="button"
                className={styles.actionBtnDanger}
                onClick={(e) => {
                  e.stopPropagation();
                  onRemove(paymentMethod);
                }}
              >
                הסר
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
